import React from "react";
import { DIFFICULTY_META } from "../../data/constants";
import { useTheme } from "../../context/ThemeContext";

export default function DiffPip({ level }) {
  const { dark } = useTheme();
  const m = DIFFICULTY_META[level] || DIFFICULTY_META.Medium;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: dark ? `${m.dot}1A` : m.bg, border: `1px solid ${dark ? `${m.dot}55` : `${m.color}20`}`, borderRadius: 6, color: dark ? m.dot : m.color, fontSize: 10, padding: "4px 8px", fontWeight: 600, letterSpacing: "0.06em", lineHeight: 1, flexShrink: 0 }}>
      <span style={{ width: 5, height: 5, borderRadius: 1, background: m.dot, flexShrink: 0 }} />
      {level}
    </span>
  );
}
